import { BASE_API_URL } from "../../../../config/url";

export const EMAIL_STORE = "EMAIL_STORE";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const SET_CURRENT_USER_LOGEDIN = "user/SET_CURRENT_USER_LOGEDIN";
export const REMOVE_SET_CURRENT_USER_LOGEDIN="REMOVE_SET_CURRENT_USER_LOGEDIN"
export const AUTH_API_URL = `${BASE_API_URL}/onboarding/user`;
